import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'

export const createTargetProductFilter = (targetProductId: number | undefined, fieldName: string) => ({
  name: fieldName,
  filters: [
    targetProductId
      ? {
          value: targetProductId,
          operator: Operators.EqualTo,
        }
      : {
          operator: Operators.IsNull,
          value: undefined,
        },
  ],
})
